import React, { useId } from 'react'

// components
import Input from '../../atoms/Input/Input'
import FormItem from '../../atoms/FormItem/FormItem'

// types
import { InputFormFieldProps } from './types'

// component
const InputFormField = (props: InputFormFieldProps) => {
	const {
		input: { value, onChange, onBlur, onFocus },
		meta: { invalid, error },
		label,
		htmlFor,
		required,
		labelScreenReaderOnly,
		id,
		...restProps
	} = props

	const generatedId = useId()
	const inputId = id ?? htmlFor ?? (label ? generatedId : undefined)
	const invalidStatus = !!(error || invalid)

	return (
		<FormItem
			htmlFor={inputId}
			label={label}
			labelScreenReaderOnly={labelScreenReaderOnly}
			required={required}
			error={invalidStatus && error ? error : undefined}
		>
			<Input
				id={inputId}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				onFocus={onFocus}
				invalid={invalidStatus}
				{...restProps}
			/>
		</FormItem>
	)
}

export default InputFormField
